import axiosInstance from '../axios/axiosInstance';

export interface UpscalePricing {
  factor: number;
  cost: number;
}

export interface UpscalePricingResponse {
  upscalePricing: UpscalePricing[];
}

export const getAvailableUpscalePricing = async (
  generationId: string
): Promise<UpscalePricingResponse> => {
  try {
    const response = await axiosInstance.get(`/upscale/pricing/${generationId}`);
    return response.data;
  } catch (error) {
    return { upscalePricing: [] };
  }
};

interface UpscaleBodyProps {
  upscaleFactor: number;
  generation: string;
}

interface UpscaleResponse {
  response: {
    jobId?: string;
    [key: string]: any; // Assuming response can have other properties
  } | null;
  error: any;
}

export const upscaleImage = async (body: UpscaleBodyProps): Promise<UpscaleResponse> => {
  try {
    const response = await axiosInstance.post(`/upscale`, body);
    if (response.data.error) {
      return { response: null, error: response.data.error };
    }
    return { response: response.data, error: null };
  } catch (error) {
    return { response: null, error: error };
  }
};

export const isUpscaleSaved = async (generationId: string): Promise<boolean> => {
  try {
    const response = await axiosInstance.get(`/upscale/${generationId}/saved`);
    return response.data.isSaved;
  } catch (error) {
    return false;
  }
};

// saves add the upscale post to the upscaleCollection of the post
export const createUpscalePost = async (
  generationId: string,
  upscaleFactor?: number,
  upscaleUrl?: string
) => {
  try {
    const postResponse = await axiosInstance.post(`/upscale/save`, {
      generationId: generationId
    });
    return { postResponse, error: null };
  } catch (error) {
    return { postResponse: null, error };
  }
};

export const setMainUpscale = async (
  generationId: string,
  upscaleUrl?: string,
  upscaleFactor?: number
) => {
  try {
    const response = await axiosInstance.post(`/upscale/setMain`, {
      generationId: generationId,
      upscaleUrl: upscaleUrl,
      upscaleFactor: upscaleFactor
    });
    return response.data;
  } catch (error) {
    return null;
  }
};
